import { createSelector, createSlice } from "@reduxjs/toolkit";
import { IStateDefaults } from "../../types/shared";
import { authActions } from "../auth/authSlice";
import { IUser } from "../../types/api";
import { RootState } from "../../store";
import { getUsers } from "./userActions";

interface UserState extends IStateDefaults {
    users: IUser[];
}

const initialState: UserState = {
    loading: false,
    success: false,
    users: [],
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(authActions.logout, state => {})
            .addCase(getUsers.fulfilled, (state, { payload }) => {
                state.users = payload.users;
            });
    },
});

export const userActions = {
    ...userSlice.actions,
    getUsers: getUsers,
};

export default userSlice.reducer;

export const selectUsers = createSelector(
    [(state: RootState) => state.user],
    user => user.users,
);
